<template>
    <nav class="navbar navbar-expand-md py-3 materialBackgroundFlipped" style="width: 100%;overflow: clip;">
        <div class="container flex-column flex-md-row justify-content-center justify-content-md-between">
            <NuxtLink class="navbar-brand d-flex align-items-center" to="/"><span class="d-flex justify-content-center align-items-center me-2" style="overflow: clip;border-radius: 9999px;"><img style="height: 3rem;width: 3rem;" src="/img/android-chrome-192x192.png"></span><span style="font-family: 'Lexend', serif;font-weight: 500;color: rgb(255,107,23);">AI<span style="color: rgb(255, 255, 255);">Boosted</span></span></NuxtLink>
        </div>
    </nav>
  <main>
    <slot></slot>
  </main>
  <CustomFooter></CustomFooter>
</template>
<style>
.offerButton {
    background: rgb(255,107,23); 
    padding: 0.5rem; 
    padding-left: 0.7rem;
    padding-right: 0.7rem;
    border-radius: 999px; 
    place-items: center; 
    display: grid; 
    color: white; 
    text-decoration: none;
    transition: background;
    transition-duration: 250ms;
    transition-timing-function: ease-in-out;
}

.offerButton:hover {
    background: rgb(176, 74, 15); 
}
</style>